export default "__VITE_ASSET__BUqd8sKW__"